export enum GregorioShape {
  UNDETERMINED,
  PUNCTUM,
  PUNCTUM_END_OF_GLYPH,
  PUNCTUM_INCLINATUM_ASCENDENS,
  PUNCTUM_INCLINATUM_STANS,
  PUNCTUM_INCLINATUM_DESCENDENS,
  PUNCTUM_INCLINATUM_DEMINUTUS,
  PUNCTUM_INCLINATUM_AUCTUS,
  VIRGA,
  VIRGA_REVERSA,
  BIVIRGA,
  TRIVIRGA,
  ORISCUS_ASCENDENS,
  ORISCUS_DESCENDENS,
  ORISCUS_DEMINUTUS,
  ORISCUS_SCAPUS_ASCENDENS,
  ORISCUS_SCAPUS_DESCENDENS,
  QUILISMA,
  STROPHA,
  STROPHA_AUCTA,
  DISTROPHA,
  TRISTROPHA,
  LINEA_PUNCTUM,
  FLAT,
  FLAT_PAREN,
  SHARP,
  SHARP_PAREN,
  NATURAL,
  NATURAL_PAREN,
  /* special shapes that must not appear in the final form of the score :
    * quadratum is the shape of the first note of a punctum quadratum
    * and quilisma quadratum is the shape of the first note of a pes
    * quislisma quadratum */
  ORISCUS_UNDETERMINED,
  ORISCUS_SCAPUS_UNDETERMINED,
  QUADRATUM,
  PUNCTUM_INCLINATUM_UNDETERMINED,
  /* those shapes are for now used only in gregoriotex */
  QUILISMA_QUADRATUM,
  PUNCTUM_AUCTUS_ASCENDENS,
  PUNCTUM_AUCTUS_DESCENDENS,
  PUNCTUM_DEMINUTUS,
  LINEA
}

export function punctumInclinatum(orientation: string) {
  switch (orientation) {
    case '0':
      return GregorioShape.PUNCTUM_INCLINATUM_DESCENDENS;
    case '2':
      return GregorioShape.PUNCTUM_INCLINATUM_STANS;
    case '1':
      return GregorioShape.PUNCTUM_INCLINATUM_ASCENDENS;
  }

  return GregorioShape.PUNCTUM_INCLINATUM_UNDETERMINED;
}
